<template>
  <div class="game-card">
    <img :src="imageSrc" :alt="title" class="game-img" />

    <div class="game-overlay">
      <div class="overlay-top">
        <span class="provider">{{ title }}</span>
        <button class="fav-btn">🤍</button>
      </div>
      <div class="overlay-bottom">
        <router-link
          v-bind:to="'/' + homeGetLink"
          ref="gameLink"
          class="play-btn"
        >
          Play
        </router-link>
        <button class="demo-btn">Demo</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GameCard",
  props: {
    title: String,
  },

  computed: {
    imageSrc() {
      const name = (this.title || "").toString();

      if (name) {
        try {
          return require(`@/assets/img/games/backup/${name}.png`);
        } catch (e) {
          try {
            return require(`@/assets/img/games/backup/${name}.jpg`);
          } catch (e) {
            try {
              return require(`@/assets/img/games/backup/${name}.jpeg`);
            } catch (e) {}
          }
        }
      }

      try {
        return require("@/assets/img/anon.png");
      } catch (e) {
        return "";
      }
    },
    homeGetLink() {
      let link = this.title;
      if (link === "cases" || link === "slots") {
        link = "unbox";
      }
      return link;
    },
  },
};
</script>

<style scoped>
.game-card {
  width: clamp(120px, 100%, 220px);
  aspect-ratio: 4 / 3; /* keeps all cards the same shape */
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1e1e1e;
}

.game-img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* ensures same height images */
}

/* Overlay is hidden by default */
.game-overlay {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(180deg, rgba(36, 36, 41, 0.16), #242429),
    linear-gradient(
      180deg,
      rgba(24, 24, 27, 0),
      rgba(24, 24, 27, 0.65) 65.13%,
      rgba(24, 24, 27, 0.65)
    );
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.game-card:hover .game-overlay {
  opacity: 1;
  pointer-events: auto;
}

.overlay-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.provider {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.fav-btn {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
}

.overlay-bottom {
  display: flex;
  justify-content: space-between;
  gap: 6px;
}

.play-btn,
.demo-btn {
  flex: 1;
  padding: 0.75rem 1rem;
  font-size: 13px;
  border-radius: 9999px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-align: center;
}

.play-btn {
  background-color: rgb(203 190 137);
  color: rgb(24 24 27);
}

.demo-btn {
  border: 2px solid hsla(0, 0%, 100%, 0.06);
  background-color: hsla(0, 0%, 100%, 0.12);
  color: hsla(0, 0%, 100%, 0.5);
  backdrop-filter: blur(6px);
}
</style>
